<template>
    <div class="pb-5">
        <b-button
            :to="{ name: 'ParticipatePreface', query: { ...$route.query}}"
            class="px-3 text-left border-0 fw-500"
            :variant="home_active_sytle === true ? 'icon-blue' : 'icon-light'"
            style="height: 48px; border-radius: 0"
            block
            >
            <fa icon="map-marker-alt" class="mr-1"/> {{ $t('안내') }}
        </b-button> 
        
        <template v-if="template_in_progress_loaded === true && custom_template_loaded === true">
            <b-list-group v-for="(lv1,idx) in new_question_list"
                :key="lv1.id"
                :class="home_active_sytle === false ? 'question-active' : ''"
                class="mb-1"
                >
                <button type="button"
                    class="pl-3 py-1 fw-500 category1s"
                    :aria-controls="`cat-${idx}`"
                    :aria-expanded="visible[idx] === true ? 'true' : 'false'"
                    @click="toggleList(idx)"
                    >
                    <fa :icon="visible[idx] === true ? 'caret-down' : 'caret-right'" class="mr-1"></fa>
                    {{ showTranslation(lv1.category1_name, lv1.category1_name_e, lv1.category1_name_c) }}
                </button>
                <b-collapse :id="`cat-${idx}`" v-model="visible[idx]">
                    <!-- 링크라 새 탭 열기·주소 복사·키보드 이동이 된다. 본문 로딩은 Questions 가 URL 변화를 보고 한다 -->
                    <b-list-group-item v-for="lv3 in lv1.category3"
                        :key="lv3.question_code"
                        :to="questionLink(lv3)"
                        :aria-current="$route.params.question_code == lv3.question_code ? 'page' : null"
                        class="d-flex justify-content-between"
                        :class="[$route.params.question_code == lv3.question_code ? `active`: '', 'category3s']"
                        >
                        {{ showTranslation(lv3.question_name, lv3.question_name_e, lv3.question_name_c) }}
                        <span v-if="lv3.is_completed === 'true'" v-b-tooltip.hover :title="$t('답변 완료')">
                            <fa style="width:0.8rem;" :icon="['fas', 'square']" class="mr-1"></fa>
                            <span class="sr-only">{{ $t('답변 완료') }}</span>
                        </span>
                        <span v-else v-b-tooltip.hover :title="$t('답변 작성중')" class="gray-550">
                            <fa style="width:0.8rem;" :icon="['far','square']" class="mr-1"></fa>
                            <span class="sr-only">{{ $t('답변 작성중') }}</span>
                        </span>
                    </b-list-group-item>
                </b-collapse>
            </b-list-group>
        </template>
        <template v-else>    
            <div class="px-3">
                <b-skeleton animation="wave" width="85%" height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%" height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="55%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="85%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%" height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
                <b-skeleton animation="wave" width="70%"  height="30px" class="my-3"></b-skeleton>
            </div>
        </template>           
        <hr class="border-0 pb-5">
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'QuestionList',
    data () {
        return {
            visible: []
        };
    },
    computed: {
        ...mapState(['template_in_progress','template_in_progress_loaded']),
        ...mapState('industry_campaigns', ['custom_template_loaded']),
        home_active_sytle () {
            return this.$route.name !== 'Questions';
        },
        template_contents() {
            return this.template_in_progress.template_contents;
        },
        new_question_list(){
            let new_list = [];
            this.template_contents.forEach( x=> {
                let new_obj = {};
                new_obj.category1_name = x.question_name;
                new_obj.category1_name_e = x.question_name_e;
                new_obj.category1_name_c = x.question_name_c;
                new_obj.category3 = [];
                x.children.forEach(y => {
                    y.children.forEach(z => new_obj.category3.push(z));
                });
                new_list.push(new_obj);
            });
            return new_list;
        }
    },
    watch: {
        // 대분류 수가 바뀔 때만 펼침 상태를 초기화한다 (문항 이동·완료 체크로 접어 둔 목록이 다시 펼쳐지지 않게)
        'new_question_list.length': {
            immediate: true,
            handler (length) {
                this.visible = Array(length).fill(true);
            }
        }
    },
    mounted() {
        // 파이프라인 오버레이·미답변 목록의 '문항으로 이동'
        this.$EventBus.$on('Questions-pipeline_overlay_question_clicked', this.goQuestion);
    },
    beforeDestroy() {
        this.$EventBus.$off('Questions-pipeline_overlay_question_clicked', this.goQuestion);
    },
    methods: {
        questionLink (question) {
            const { pc, cmp, cpn } = this.$route.query;
            return {
                name: 'Questions',
                params: { question_code: question.question_code },
                query: { pc, cmp, cpn }
            };
        },
        goQuestion (question) {
            if (this.$route.params.question_code === question.question_code) return; // 같은 문항이면 입력 중 내용 보존
            this.$router.push(this.questionLink(question));
        },
        toggleList(idx){
            this.visible.splice(idx, 1, this.visible[idx] !== true);
        }
    }
};
</script>

<style scoped>
.category1s{
    /* background: linear-gradient(90deg, var(--gray-300), var(--gray-200)); */
    display: block;
    width: 100%;
    text-align: left;
    color: inherit;
    background: transparent;
    border: 0;
    border-bottom: 1px solid var(--gray-300);
}
.category3s:hover,
.category3s:focus{
    text-decoration: none;
}
.category3s{
    border: 0;
    border-radius: 0;
    letter-spacing: -0.2px;
    cursor: pointer;
    background-color: var(--gray-200);
    font-size: 0.9rem;
    color: var(--gray-600);
    padding: 0.25rem 1rem 0.25rem 1.75rem ;
}
.category3s:hover{
    background-color: var(--gray-300);
}

.question-active .category1s {
    color: var(--gray-100);
    border-bottom: 1px solid var(--gray-400);
    font-weight: 400;
}

.question-active .category3s{
    color: var(--gray-300);
    background-color: var(--gray-650);
    font-weight: 300;
}
.question-active .node-level-1:hover {
    color: var(--gray-50);
    border-bottom: 1px solid var(--gray-400);
}
.question-active .category3s:hover{
    background-color: var(--gray-700);
    color: var(--gray-100);
}
.question-active .node-level-1-active,
.question-active .category3s.active,
.question-active .node-level-3-active,
.question-active .node-level-4-active {
    background-color: var(--blue);
    color: var(--gray-100);
}
.question-active .node-level-1-active:hover,
.question-active .category3s.active:hover,
.question-active .node-level-3-active:hover,
.question-active .node-level-4-active:hover {
    background-color: var(--blue5);
    color: var(--gray-100);
}

[id^='cat'] > .list-group-item.active {
    background-color: var(--blue);
    border: 0;
}

.print-aside{
    top: 0;
    right:0; 
    margin-right:-44px;
    z-index: 1;
}
.print-aside:hover{
    top: 0;
    right:0; 
    margin-right:-195px;
}
</style>
